module.exports = __webpack_public_path__ + "img/bauger_02.c5c45174.png";